// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1C8p7","head":"Table_head__1NRuo","col":"Table_col__35Xey"};